type TileHeaderProps = {
  title: string;
  subtitle: string;
};

const TileHeader: React.FC<TileHeaderProps> = ({ title, subtitle }) => {
  return (
    <div className="flex flex-col dark:text-white">
      <span className="font-semibold text-[#000000d1] text-[18px] leading-[18px] sm:text-[20px] sm:leading-[20px]">
        {title}
      </span>
      <div className="flex justify-between">
        <span className="text-[#000000b9]">Total:</span>
        <span className="text-[#000000b9] font-semibold">${subtitle}</span>
      </div>
    </div>
  );
};

export default TileHeader;
